<template>
    <div style="background-color: white">
        <div style="width: 100%; height: 5px; background-color: #eeeeee"></div>
        <van-tabs v-if="show"
                v-model="active"
                title-active-color="#ee0a24"
                @change="onChange"
                swipeable
                scrollspy sticky
                :offset-top="$route.path === '/select' ? more_tab_margin_top : '45px'"
        >
            <blockquote v-for="(item, index) in list" v-bind:key="index">
                <van-tab v-if="$common.isShowComponent(item)" >
                    <template slot="title"
                    ><span>{{ item.props.text }}</span></template
                    >
                </van-tab>
            </blockquote>

            <div class="listStyle" v-if="true">
                <Wp_pull_list
                        :all-params="all_params"
                        :url="url"
                        :page-size="page_size"
                        @onLoad="onLoad"
                >
                    <div v-if="$common.getPid()">
                        <div v-if="$common.isClient()">
                            <van-grid :column-num="2" :border="false">
                                <van-grid-item
                                        v-for="(sku_info, index) in data_list"
                                        :key="index"
                                >
                                    <div
                                            slot="default"
                                            style="box-shadow: 1px 1px 5px #999999; border-radius: 10px"
                                    >
                                        <JdSkuInfoCard
                                                ref="JdSkuInfoCard"
                                                :skuInfo="sku_info"
                                                :img-gray="imgGray"
                                                :show-simple-button="show_simple_button"
                                                @showAllButton="showAllButton"
                                                @addInSelectList="addInSelectList"
                                                @getAllRobatSkuData="getAllRobatSkuData"
                                                @updataBadegSync="updataBadegSync"
                                                orientation="vertical"
                                        ></JdSkuInfoCard>
                                    </div>
                                </van-grid-item>
                            </van-grid>
                        </div>

                        <div v-else>
                            <JdSkuInfoCard
                                    ref="JdSkuInfoCard"
                                    v-for="(sku_info, index) in data_list"
                                    v-bind:key="index"
                                    :skuInfo="sku_info"
                                    :img-gray="imgGray"
                                    :show-simple-button="show_simple_button"
                                    @showAllButton="showAllButton"
                                    @addInSelectList="addInSelectList"
                                    @getAllRobatSkuData="getAllRobatSkuData"
                                    @updataBadegSync="updataBadegSync"
                            ></JdSkuInfoCard>
                        </div>


                    </div>

                    <div v-else style="padding: 0px 5px">
                        <!--                            <JdSkuInfoCard_No_Pid-->
                        <!--                                    v-for="(sku_info, index) in data_list"-->
                        <!--                                    v-bind:key="index"-->
                        <!--                                    :skuInfo="sku_info"-->
                        <!--                                    :img-gray="imgGray"-->
                        <!--                                    @addInSelectList="addInSelectList"-->
                        <!--                            ></JdSkuInfoCard_No_Pid>-->

                        <van-grid :column-num="2" :border="false">
                            <van-grid-item
                                    v-for="(sku_info, index) in data_list"
                                    :key="index"
                            >
                                <div
                                        slot="default"
                                        style="box-shadow: 1px 1px 5px #999999; border-radius: 10px"
                                >
                                    <JdSkuInfoCard_No_Pid
                                            :skuInfo="sku_info"
                                            :img-gray="imgGray"
                                            orientation="vertical"
                                            @addInSelectList="addInSelectList"
                                    ></JdSkuInfoCard_No_Pid>
                                </div>
                            </van-grid-item>
                        </van-grid>
                    </div>
                </Wp_pull_list>
            </div>
        </van-tabs>

        <!--        <div v-if="allRobotSkuData">-->
        <!--            <Wp_join_robot_list_mark_model ref="Wp_join_robot_list_mark_model"-->
        <!--                                           :all-robot-sku-data="allRobotSkuData"-->
        <!--                                           @updataJoinRobotButtonStatus="updataJoinRobotButtonStatus"-->
        <!--            ></Wp_join_robot_list_mark_model>-->
        <!--        </div>-->

        <!--        <div v-if="select_skuInfo_list && select_skuInfo_list.length > 0"-->
        <!--             style="position: fixed; right: -1px; bottom: 130px">-->
        <!--            <Badge :count="select_skuInfo_list.length" style="position: absolute;"></Badge>-->
        <!--            <van-button-->
        <!--                    style="margin-left: 9px; margin-top: 9px;"-->
        <!--                    type="danger"-->
        <!--                    @click="showSelectList"-->
        <!--            >选品清单-->
        <!--            </van-button>-->
        <!--        </div>-->

        <!--        &lt;!&ndash;选品清单sheet&ndash;&gt;-->
        <!--        <JdSelectListSheet ref="jdSelectListSheet"></JdSelectListSheet>-->
        <Wp_select_list_mark_model
                ref="Wp_select_list_mark_model"
        ></Wp_select_list_mark_model>
    </div>
</template>

<script>
    import JdSkuInfoCard from "../custom/JdSkuInfoCard";
    import JdSkuInfoCard_No_Pid from "../custom/JdSkuInfoCard_No_Pid";
    import Wp_pull_list from "../list/Wp_pull_list";
    import Wp_select_list_mark_model from "../custom/Wp_select_list_mark_model";
    import Wp_join_robot_list_mark_model from "../custom/Wp_join_robot_list_mark_model";

    export default {
        name: "Wp_home_more_model",
        components: {
            // eslint-disable-next-line vue/no-unused-components
            Wp_join_robot_list_mark_model,
            Wp_select_list_mark_model,
          Wp_pull_list,
            JdSkuInfoCard_No_Pid,
            JdSkuInfoCard,
        },
        //子组件中可通过相应配置，获得父组件的this
        provide() {
            return {
                JdSelectListSheet_parent: this,
            };
        },

        inject: ["JdSelectListSheet_parent"],

        props: {
            // datas:{type: Array}
            params: {type: Object},
            list: {type: Array},
            imgGray: {type: Boolean, default: false},
        },
        data() {
            return {
                morePropsList: [],
                active: 0,
                //下拉刷新结束
                isLoading: false,
                //上拉加载的临时list
                data_list: [],
                //上拉加载状态结束
                loading: false,
                //数据全部加载完成的状态
                finished: false,
                finishedText: "已获取全部数据",
                //请求数据页码
                page_index: 1,
                //一次页面请求多少数据
                page_size: 20,
                all_params: {},
                // //选品清单，内容为skuId
                // select_skuId_list: [],
                // //选品清单中的商品信息集合
                // select_skuInfo_list: [],
                //
                // //添加到选品清单中的商品数量上限
                // select_sku_length_limit: 9,
                url: "",
                allRobotSkuData: null,
                show_simple_button: true,

                show: false,

                more_tab_margin_top: "95px",
            };
        },
        created() {
            this.initDatas();
            // document.documentElement.scrollTop = document.body.scrollTop = 0;
            // this.initMoreDatas();
        },

        mounted() {
            setTimeout(() => {
                this.updataJoinRobotButtonStatus();
            }, 2000);
            setTimeout(()=>{
                this.show = true;
            }, 200);

            this.$bus.$on("more_tab_margin_top", result=>{
                this.more_tab_margin_top = result;
            })
        },

        methods: {
            getOffsetTop(){
                setTimeout(()=>{
                    return '45px'
                }, 200)

            },
            showAllButton() {
                this.show_simple_button = false;
                this.$common.show_sku_card_simple_button_model = false;
            },

            initDatas() {
                if (
                    this.list &&
                    this.list.length > 0 &&
                    this.list[this.active].props.url
                ) {
                    this.url = this.list[this.active].props.url;
                }

                this.initAllParams();
            },

            /**
             * 获取群主提交到助理的数据列表
             */
            initSkuListFromRobot() {
                this.$getAllDataListFromRobot_withLimitTime();

                this.allRobotSkuData = this.$common.global_sku_all_data;
                if (!this.$common.isClient_whole()) {
                    setTimeout(() => {
                        if (this.allRobotSkuData && this.$refs.JdSkuInfoCard) {
                            if (this.JdSelectListSheet_parent) {
                                //将助理发品数据以及当前页面中的JdSkuInfoCard，发送到select页面，用于select页面中的公共Wp_join_robot_list_mark_model使用
                                this.JdSelectListSheet_parent.getAllRobatSkuDataFrom_Wp_home_more_model(
                                    this.allRobotSkuData,
                                    this.$refs.JdSkuInfoCard
                                );
                            }
                        }
                    }, 500);
                }
            },

            /**
             * 更新角标（来自JdSkuInfoCard）
             */
            updataBadegSync(addOne) {
                if (this.$refs.Wp_join_robot_list_mark_model) {
                    this.$refs.Wp_join_robot_list_mark_model.updataBadegSync(addOne);
                }
            },

            /**
             * 添加一个商品到助理后，获取全部数据用于更新清单中的数据（来自JdSkuInfoCard）
             */
            getAllRobatSkuData(data) {
                if (!this.$common.isClient_whole()) {
                    if (this.JdSelectListSheet_parent) {
                        //将助理发品数据以及当前页面中的JdSkuInfoCard，发送到select页面，用于select页面中的公共Wp_join_robot_list_mark_model使用
                        this.JdSelectListSheet_parent.getAllRobatSkuDataFrom_Wp_home_more_model(
                            data,
                            this.$refs.JdSkuInfoCard
                        );
                        // this.$refs.Wp_join_robot_list_mark_model.getAllRobatSkuData(data);
                    }
                }
            },

            updataJoinRobotButtonStatus() {
                if (this.$refs.JdSkuInfoCard) {
                    for (let i = 0; i < this.$refs.JdSkuInfoCard.length; i++) {
                        this.$refs.JdSkuInfoCard[i].updateJoinRobotButtonStatus();
                    }
                }
            },

            // initMoreDatas(){
            //     if(this.params){
            //
            //         if(this.params.list){
            //             this.morePropsList = this.params.list;
            //         }
            //
            //     }
            // },

            /**
             * 显示商品清单
             */
            showSelectList() {
                // this.getSelectSkuList();
                if (this.select_skuInfo_list && this.select_skuInfo_list.length > 0) {
                    // this.showSelect = true;
                    this.$refs.jdSelectListSheet.showSelect = true;
                }
            },

            /**
             * 添加商品到选品清单中
             */
            addInSelectList(skuInfo, skuId) {
                this.$refs.Wp_select_list_mark_model.addInSelectList(skuInfo, skuId);

                // if (this.select_skuInfo_list.length === this.select_sku_length_limit) {
                //     this.$dialog.alert({
                //         message: '[选品清单]以达到最大限额'
                //     });
                //     return;
                // }
                //
                // if (this.select_skuId_list.includes(skuId)) {
                //     // this.$toast.fail("该商品已加入[选品清单]")
                //     this.$dialog.alert({
                //         message: '该商品已加入[选品清单]'
                //     });
                // } else {
                //     this.select_skuInfo_list.push(skuInfo)
                //     this.select_skuId_list.push(skuId)
                // }
            },

            onChange(v) {
                this.$log("onChang = " + v);
                this.active = v;
                this.initDatas();
                this.initStatus();
                this.onLoad();
            },

            /**
             * 重新获取数据时，重新初始化各种状态
             */
            initStatus() {
                this.all_params.page = 1;
                this.data_list = [];
            },

            onLoad(list) {
                this.initSkuListFromRobot();

                //选品清单重置
                this.$refs.Wp_select_list_mark_model.releaseSelectData();

                this.data_list = list;
            },

            // loadDatas(datas) {
            //     if (datas) {
            //
            //
            //         if(datas.length === 1 && this.data_list.length === 1){
            //             this.$log("this.data_list.indexOf(datas[0]) = " + (this.data_list[0].skuId === datas[0].skuId))
            //             if(this.data_list[0].skuId === datas[0].skuId){
            //
            //                 // 加载状态结束
            //                 this.loading = false;
            //                 // 获取数据结束
            //                 this.finished = true;
            //                 this.finishedText = "已获取全部商品~";
            //                 return;
            //             }
            //         }
            //
            //         for (let i = 0; i < this.page_size; i++) {
            //             if(datas[i]){
            //                 this.data_list.push(datas[i]);
            //             }
            //         }
            //         // this.data_list = datas;
            //
            //         // 加载状态结束
            //         this.loading = false;
            //
            //         this.all_params.page += 1;
            //     } else {
            //         // 加载状态结束
            //         this.loading = false;
            //         // 获取数据结束
            //         this.finished = true;
            //         this.finishedText = "已获取全部商品~";
            //         if((!this.data_list || this.data_list.length === 0) && this.url_param_value){
            //             this.finishedText = "未搜索到相关商品";
            //         }
            //     }
            //     //关闭下拉刷新
            //     this.isLoading = false;
            // },

            initAllParams() {
                if (!this.all_params || !this.all_params.page) {
                    this.all_params.page = this.page_index;
                    this.all_params.size = this.page_size;
                }
            },

            // getMoreDatas(params, fn){
            //     if(this.list && this.list.length > 0 && this.list[this.active].props.url){
            //         this.$getDatasWithUrlAndParams(this.list[this.active].props.url, params, response=>{
            //             // this.$log(response)
            //             if(response && response.code === 200){
            //                 if(fn){
            //                     fn(response.data);
            //                 }
            //             }
            //         })
            //     }
            //
            // }
        },
    };
</script>

<style scoped>
    /deep/ .van-tab--active {
        color: #323233;
        font-weight: 500;
        font-size: 18px;
    }

    /deep/ .van-grid-item .van-grid-item__content {
        background-color: rgba(255, 255, 255, 0);
        padding: 5px;
    }


</style>